export const metodosPagamentosDfe = [
  {
    id: "01",
    descricao: "DINHEIRO",
  },
  {
    id: "02",
    descricao: "CHEQUE",
  },
  {
    id: "03",
    descricao: "CARTÃO DE CRÉDITO",
  },
  {
    id: "04",
    descricao: "CARTÃO DE DÉBITO",
  },
  {
    id: "05",
    descricao: "CARTÃO DA LOJA",
  },
  {
    id: "10",
    descricao: "VALE ALIMENTAÇÃO",
  },
  {
    id: "11",
    descricao: "VALE REFEIÇÃO",
  },
  {
    id: "12",
    descricao: "VALE PRESENTE",
  },
  {
    id: "13",
    descricao: "VALE COMBUSTÍVEL",
  },
  {
    id: "14",
    descricao: "DUPLICATA MERCANTIL",
  },
  {
    id: "15",
    descricao: "BOLETO BANCÁRIO",
  },
  {
    id: "16",
    descricao: "DEPÓSITO BANCÁRIO",
  },
  {
    id: "17",
    descricao: "PIX DINÂMICO",
  },
  {
    id: "18",
    descricao: "CARTEIRA DIGITAL",
  },
  {
    id: "19",
    descricao: "CRÉDITO VIRTUAL",
  },
  {
    id: "20",
    descricao: "PIX ESTÁTICO",
  },
  {
    id: "21",
    descricao: "CRÉDITO EM LOJA",
  },
  {
    id: "22",
    descricao: "PAGAMENTO NÃO INFORMADO",
  },
  {
    id: "90",
    descricao: "SEM PAGAMENTO",
  },
  {
    id: "99",
    descricao: "OUTROS",
  },
];
